import { render, staticRenderFns } from "./rmib-question.vue?vue&type=template&id=60a59c5c&"
import script from "./rmib-question.vue?vue&type=script&lang=js&"
export * from "./rmib-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports